<template>
	<calendar></calendar>
</template>

<script>
import Calendar from './components/Calendar'

export default {
	name: 'app',
	components: {
		Calendar
	}
}
</script>

<style lang="scss">
	/* Reset */
	html,body,div,span,applet,object,iframe,h1,h2,h3,h4,h5,h6,p,blockquote,pre,a,abbr,acronym,address,big,cite,code,del,dfn,em,img,ins,kbd,q,s,samp,small,strike,strong,sub,sup,tt,var,b,u,i,center,dl,dt,dd,ol,ul,li,fieldset,form,label,legend,table,caption,tbody,tfoot,thead,tr,th,td,article,aside,canvas,details,embed,figure,figcaption,footer,header,hgroup,menu,nav,output,ruby,section,summary,time,mark,audio,video{margin:0;padding:0;border:0;font-size:100%;font:inherit;vertical-align:baseline;box-sizing:border-box;}article,aside,details,figcaption,figure,footer,header,hgroup,menu,nav,section{display:block}body{line-height:1}ol,ul{list-style:none}blockquote,q{quotes:none}blockquote:before,blockquote:after,q:before,q:after{content:'';content:none}table{border-collapse:collapse;border-spacing:0}

	* {
		box-sizing: border-box;
	}

	html,
	body {
		width: 100%;
		height: 100%;
		overflow: hidden;
	}

	body {
		display: flex;
		align-items: center;
		justify-content: center;
		padding: 2em;
		font: 400 1em/2 -apple-system, BlinkMacSystemFont, "Roboto", "Droid Sans", "Helvetica Neue", Helvetica, Arial, sans-serif;
		color: #333;
	}

	input,
	button,
	textarea {
		font: inherit;
	}

</style>



// WEBPACK FOOTER //
// App.vue?097b4efc